import request from '@/utils/request'

//文章管理列表 type 1总部公告 2新闻消息 3关于证书
export function articleList(data) {
	data.status = 1
	let name = ''
	let list = [
		'项目介绍',
		'证书介绍',
		'考试公告',
		'政策文件',
		'关于证书',
		'考试认证',
		'参考资料',
		'证书首条',
		'前台协议',
	]
	return request({
		url: '/article/list-page',
		headers: { 'oper': '获取'+ list[data.type - 2] +'文章列表', 'oper-type': '190' + data.type },
		method: 'post',
		data
	})
}

// 账号信息管理列表
export function userList(data) {
	return request({
		url: 'user/list',
		method: 'post',
		headers: { 'oper': '账号信息管理列表', 'oper-type': 1027 },
		data
	})
}

// 账号信息查看详情
export function userDetail(data) {
	return request({
		url: 'user/detail',
		method: 'post',
		headers: { 'oper': '账号信息查看详情', 'oper-type': 1028 },
		data
	})
}
// 证书查询结果弹窗显示
export function certificate(data) {
	return request({
		url: 'article/list-page-ext',
		method: 'post',
		data
		
	})
}
// 账号信息查看详情修改
export function userUpdate(data) {
	return request({
		url: 'user/update',
		method: 'post',
		headers: { 'oper': '账号信息查看详情修改', 'oper-type': 1029 },
		data
	})
}

//list by type 类型筛选数据
export function listByType(type) {
    return request({
        url: 'dict/list/'+type,
        headers: { 'oper': '获取页面底栏', 'oper-type': 1030 },
        method: 'get',
    })
}

export function linkListPage(data) {
	return request({
		url: 'link/list-page',
		headers: { 'oper': '获取友情链接列表', 'oper-type': 1031 },
		method: 'post',
		data
	})
}
